export default "__VITE_ASSET__99700951__"